var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCrucible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 387.34 64.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:#2684ff;}.cls-3{fill:url(#New_Gradient_Swatch_1);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 30.47,
    y1: 24.34,
    x2: 30.47,
    y2: 2.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Crucible-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.64,59.84c-3.61,2.38-9.33,3.43-15.31,3.43-19,0-29.74-11.44-29.74-29.66C88.59,16,99.32,3.7,118.15,3.7c5.63,0,11.26,1.06,15.4,4V15.4c-4.14-2.64-8.71-4-15.4-4-13.55,0-21.65,9-21.65,22.26S104.87,55.7,118.6,55.7a32.46,32.46,0,0,0,15-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.71,18.39h7.39v7.74c2.55-5.19,7-8.89,15.58-8.36v7.39c-9.68-1-15.58,1.94-15.58,11.26v26h-7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.31,18.39h7.57V45c0,7.92,3.17,11.44,10.38,11.44,7,0,11.88-4.66,11.88-13.55V18.39h7.57v44h-7.57V55.17a15.43,15.43,0,0,1-13.9,8.1c-10.12,0-15.93-7-15.93-19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.21,61.25c-2.64,1.41-6.69,2-10.74,2-15.66,0-23-9.5-23-23,0-13.29,7.3-22.79,23-22.79a23.26,23.26,0,0,1,10.47,2.11v7A22.18,22.18,0,0,0,241,24.55c-11.44,0-16.1,7.22-16.1,15.75s4.75,15.75,16.28,15.75a27.8,27.8,0,0,0,10-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.71,1.5A4.94,4.94,0,0,1,269,6.78a5.28,5.28,0,0,1-10.56,0A4.94,4.94,0,0,1,263.71,1.5Zm-3.87,16.9h7.57v44h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.4,63.27c-6.42,0-11.35-2.9-14-8.62v7.74h-7.57V0h7.57V26.31c2.82-5.81,8.1-8.8,14.87-8.8,11.7,0,17.6,9.94,17.6,22.88C318.88,52.8,312.72,63.27,300.4,63.27Zm-1.14-38.72c-6.78,0-12.85,4.31-12.85,14.08v3.52c0,9.77,5.54,14.08,12,14.08,8.54,0,12.94-5.63,12.94-15.84C311.31,29.83,307.09,24.55,299.26,24.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.47,62.65c-7.22,0-11.79-3.43-11.79-11.53V0h7.57V50.25c0,4,2.64,5.37,5.9,5.37a19.17,19.17,0,0,0,2.2-.09V62.3A16.11,16.11,0,0,1,339.47,62.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.24,63.27c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H355.22c1.06,7.48,5.9,12.32,16.28,12.32a39,39,0,0,0,13.38-2.38v7C381.27,62.57,375.73,63.27,371.24,63.27Zm-16.1-26h24.55c-.44-8.18-4.14-12.85-11.7-12.85C360,24.38,355.93,29.57,355.14,37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.47,2.09C13.64,2.09,0,7.84,0,14.92A6.48,6.48,0,0,0,.11,16L5.48,44.18a25.44,25.44,0,0,0,50,0L60.83,16a6.48,6.48,0,0,0,.11-1.07C60.94,7.84,47.3,2.09,30.47,2.09Zm0,46.67c-8.8,0-8.07-20.45-17.93-23.47-.82-.25-1.6-.52-2.36-.81a59.2,59.2,0,0,1,20.29-3.26,59.2,59.2,0,0,1,20.29,3.26c-.76.28-1.54.56-2.36.81-9.86,3-9.12,23.47-17.93,23.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.18,24.49a59.19,59.19,0,0,1,20.29-3.26,59.19,59.19,0,0,1,20.29,3.26c6.24-2.35,10.18-5.76,10.18-9.57,0-7.08-13.64-12.83-30.47-12.83S0,7.84,0,14.92C0,18.72,3.93,22.14,10.18,24.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrucible);
export default __webpack_public_path__ + "static/media/logo-crucible.e1a514bef5dd430b0fdfa4e548af2638.svg";
export { ForwardRef as ReactComponent };